<template>
  <div class="detalle-datos text-wrap" v-if="parada != null">
    <el-alert
      v-if="parada.estado == 'ERROR'"
      type="error"
      :title="parada.error || `Error en la ${tipoLabel.toLowerCase()}`"
      :closable="false"
      show-icon
      class="mt-2 mb-2"
    />
    <div class="detalle-secciones">
      <div class="text-break">
        <div class="h-100 px-2 pb-2">
          <el-divider content-position="left" class="my-2">
            <h6 class="detalle-titulo mb-0">{{ tipoLabel }}</h6>
          </el-divider>
          <ul class="list-unstyled mb-0">
            <li v-if="!config || config.filtros.includes('numero')"><span class="detalle-etiqueta">{{ numeroLabel }}:</span> {{ showValue(parada.numero) }}</li>
            <li v-if="!config || config.filtros.includes('referenciaCourier')">
              <span class="detalle-etiqueta">Referencia courier:</span>
              {{ showValue(parada.referenciaCourier) }}
            </li>
            <li v-if="!config || config.filtros.includes('cliente')"><span class="detalle-etiqueta">Cliente:</span> {{ clienteLabel }}</li>
            <li v-if="!config || config.tipo === 'RECOGIDA' || config.filtros.includes('courier')"><span class="detalle-etiqueta">Courier:</span> {{ formatCourier(parada.courier) }}</li>
          </ul>
        </div>
      </div>
      <div class="text-break">
        <div class="h-100 px-2 pb-2">
          <el-divider content-position="left" class="my-2">
            <h6 class="detalle-titulo mb-0">{{ contactoLabel }}</h6>
          </el-divider>
          <ul class="list-unstyled mb-0">
            <li><span class="detalle-etiqueta">Nombre:</span> {{ showValue(contacto.nombre) }}</li>
            <li><span class="detalle-etiqueta">Atención de:</span> {{ showValue(contacto.atencionDe) }}</li>
            <li><span class="detalle-etiqueta">Teléfono:</span> {{ showValue(telefonoContacto) }}</li>
            <li><span class="detalle-etiqueta">Email:</span> {{ showValue(contacto.email) }}</li>
          </ul>
        </div>
      </div>
      <div class="text-break">
        <div class="h-100 px-2 pb-2">
          <el-divider content-position="left" class="my-2">
            <h6 class="detalle-titulo mb-0">Ruta</h6>
          </el-divider>
          <ul class="list-unstyled mb-0">
            <li><span class="detalle-etiqueta">Fecha:</span> {{ formatDate(parada.fecha) }}</li>
            <li><span class="detalle-etiqueta">Horario:</span> {{ showValue(formatHorario(parada.horario)) }}</li>
            <li><span class="detalle-etiqueta">Dirección:</span> {{ showValue(parada.direccion) }}</li>
          </ul>
        </div>
      </div>
      <div class="text-break">
        <div class="h-100 px-2 pb-2">
          <el-divider content-position="left" class="my-2">
            <h6 class="detalle-titulo mb-0">Mercancía</h6>
          </el-divider>
          <ul class="list-unstyled mb-0">
            <li><span class="detalle-etiqueta">Envíos:</span> {{ showValue(parada.red) }}</li>
            <li>
              <span class="detalle-etiqueta">Bultos:</span> {{ showValue(parada.bultos) }} ({{ formatDecimal(parada.kilos) }} kg)
            </li>
            <li><span class="detalle-etiqueta">Frío:</span> {{ parada.frio === true ? 'Sí' : parada.frio === false ? 'No' : '-' }}</li>
            <li class="detalle-observaciones"><span class="detalle-etiqueta">Observaciones:</span> {{ showValue(parada.observaciones) }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatUtcDate, formatCourier, formatTipoParada, formatHorario, formatDecimal, showValue } from "@/util/utils";

export default {
  name: "detalle-parada",
  props: {
    config: { type: Object, default: null },
    parada: {
      required: true,
      default: () => null,
    },
  },
  computed: {
    tipoLabel() {
      const tipo = this.parada.tipo || (this.config && this.config.tipo);
      return formatTipoParada(tipo);
    },
    numeroLabel() {
      return this.config ? (this.config.tipo === "ENTREGA" ? "Nº entrega" : "Nº recogida") : "Número";
    },
    hasCliente() {
      if (this.config && !this.config.filtros.includes("cliente")) return false;
      return this.parada && this.parada.cliente;
    },
    contactoLabel() {
      const tipo = this.parada.tipo || (this.config && this.config.tipo);
      return tipo === "ENTREGA" ? "Destinatario" : "Remitente";
    },
    contacto() {
      return this.parada[this.contactoLabel === "Destinatario" ? "destinatario" : "remitente"] || {};
    },
    clienteLabel() {
      if (!this.hasCliente) return "-";
      const codigo = this.parada.cliente.codigo;
      const nombre = this.parada.cliente.nombre;
      return showValue([codigo, nombre].filter((value) => showValue(value) !== "-").join(" - "));
    },
    telefonoContacto() {
      const telefono = this.contacto.telefono;
      if (!telefono) return "";
      if (typeof telefono === "string") return telefono;
      return [telefono.prefijo, telefono.numero].filter(Boolean).join(" ");
    },
  },
  methods: {
    formatHorario,
    formatCourier,
    formatDecimal,
    showValue,
    formatDate: formatUtcDate,
  },
};
</script>
